
import { COMPARE_ADD_ITEM, COMPARE_REMOVE_ITEM,COMPARE_TOGGLE, } from './compareActionTypes';

export function compareToggle(show=false){
    return {type:COMPARE_TOGGLE, show}
}

export function compareAddItemSuccess(product) {
    // toast.success(`Product "${product.title}" added to compare!`, { theme: 'colored' });

    return { type: COMPARE_ADD_ITEM, product, };
}

export function compareRemoveItemSuccess(productId) {
    return { type: COMPARE_REMOVE_ITEM, productId, };
}

export function compareAddItem(product) {
    // sending request to server, timeout is used as a stub
    return (dispatch) => (
        new Promise((resolve) => {
            setTimeout(() => {
                dispatch(compareAddItemSuccess(product));
                resolve();
            }, 500);
        })
    );
}

export function compareRemoveItem(productId) {
    // sending request to server, timeout is used as a stub
    return (dispatch) => (
        new Promise((resolve) => {
            setTimeout(() => {
                dispatch(compareRemoveItemSuccess(productId));
                resolve();
            }, 500);
        })
    );
}
